import { SITE_INFO } from "../configs/info";

export default function BenefitsSection() {
  return (
      <section className="pt-8">
      <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-4 md:mb-6">
          ¿Por qué elegir TV Cielo?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="bg-white/5 backdrop-blur-md group rounded-xl p-6 shadow-lg border border-white/10 hover:bg-white/10 hover:border-orange-400/30 hover:shadow-orange-400/10 transition-all duration-700 transform hover:-translate-y-1">
            <div className="flex flex-col items-center">
              <svg
                className="w-10 h-10 text-orange-300 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17 8V5a1 1 0 0 0-1-1H6a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V6"></path>
                <path d="M20 12v4h-4a2 2 0 0 1 0-4z"></path>
              </svg>
              <h3 className="text-lg font-bold text-white mb-3 text-center w-full">
                Garantía de Reembolso
              </h3>
              <p className="text-sm text-white/80 leading-relaxed text-left w-full">
                ¿No estás satisfecho con tu suscripción IPTV? ¡No hay problema! Ofrecemos una garantía de reembolso de 15 días para un reembolso completo.
              </p>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 shadow-lg border border-white/10 hover:bg-white/10 hover:border-orange-400/30 hover:shadow-orange-400/10 transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex flex-col items-center">
              <svg
                className="w-10 h-10 text-orange-300 mb-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M21 6h-7.59l3.29-3.29L16 2l-4 4l-4-4l-.71.71L10.59 6H3a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8a2 2 0 0 0-2-2m0 14H3V8h18zM9 10v8l7-4z"
                ></path>
              </svg>
              <h3 className="text-lg font-bold text-white mb-3 text-center w-full">
                79 000+ Canales Mundiales
              </h3>
              <p className="text-sm text-white/80 leading-relaxed text-left w-full">
                Una lista completa de todos los canales europeos e internacionales. Con más de 79.000 canales, ofrecemos la mejor lista m3u del mercado para IPTV Smarters y otros reproductores.
              </p>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 shadow-lg border border-white/10 hover:bg-white/10 hover:border-orange-400/30 hover:shadow-orange-400/10 transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex flex-col items-center">
              <svg
                className="w-10 h-10 text-orange-300 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
              <h3 className="text-lg font-bold text-white mb-3 text-center w-full">
                Conexión Ultra-Rápida
              </h3>
              <p className="text-sm text-white/80 leading-relaxed text-left w-full">
                A diferencia de otros proveedores de IPTV ilegal, {SITE_INFO.siteName} utiliza servidores dedicados de alto rendimiento. Zapping ultrarrápido en menos de 0,5 segundos y sin cortes durante los partidos.
              </p>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-xl p-6 shadow-lg border border-white/10 hover:bg-white/10 hover:border-orange-400/30 hover:shadow-orange-400/10 transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex flex-col items-center">
              <svg
                className="w-10 h-10 text-orange-300 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <h3 className="text-lg font-bold text-white mb-3 text-center w-full">
                Instalación Inmediata
              </h3>
              <p className="text-sm text-white/80 leading-relaxed text-left w-full">
                Configuración sencilla de su suscripción IPTV en Smart TV, Android Box, Fire Stick o PC. Proporcionamos los códigos Xtream y m3u instantáneamente después de la compra.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

